import * as Yup from 'yup'

export const forgotPasswordSchema = {
  email: ""
}
// eslint-disable-next-line no-useless-escape
const emailRegex = /^([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,4})+$/

export const forgotPasswordValidations = Yup.object().shape({
  email: Yup.string().trim().required().matches(emailRegex, "Please enter valid email").max(100, "Email should not exeed 100 characters")
})
